/**
 * @generated SignedSource<<d711cd0941c6b4b46378081ad105178c>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type experienceRegistry_issueNavigator_SidebarExperienceRegistry_view$data = {
  readonly " $fragmentSpreads": FragmentRefs<"ConditionalFormattingSidebarExperience_view">;
  readonly " $fragmentType": "experienceRegistry_issueNavigator_SidebarExperienceRegistry_view";
};
export type experienceRegistry_issueNavigator_SidebarExperienceRegistry_view$key = {
  readonly " $data"?: experienceRegistry_issueNavigator_SidebarExperienceRegistry_view$data;
  readonly " $fragmentSpreads": FragmentRefs<"experienceRegistry_issueNavigator_SidebarExperienceRegistry_view">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "isSavedViewConditionalFormattingEnabled"
    }
  ],
  "kind": "Fragment",
  "name": "experienceRegistry_issueNavigator_SidebarExperienceRegistry_view",
  "selections": [
    {
      "condition": "isSavedViewConditionalFormattingEnabled",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "kind": "FragmentSpread",
          "name": "ConditionalFormattingSidebarExperience_view"
        }
      ]
    }
  ],
  "type": "JiraSpreadsheetView",
  "abstractKey": "__isJiraSpreadsheetView"
};

(node as any).hash = "93e874a142b401eaf0fa856c593250f2";

export default node;
